<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  comment: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div class="info__inner">
    <div class="block">
      <h2 class="title">
        {{ title }}
      </h2>
      <p class="text">
        {{ comment }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info__inner {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.block {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.title {
  color: #101010;
  font-size: 15px;
  font-weight: 600;
  line-height: 15px;
}
.text {
  margin-top: 5px;
  color: #000;
  font-size: 15px;
  line-height: 25.05px;
}
</style>
